import React from 'react';
import ProductCard from './ProductCard';

const ProductGrid = ({ products, columns = 4 }) => {
  const gridCols = {
    2: 'grid-cols-2',
    3: 'grid-cols-2 md:grid-cols-3',
    4: 'grid-cols-2 md:grid-cols-3 lg:grid-cols-4',
  };

  return (
    <div
      className={`grid ${gridCols[columns]} w-full min-w-0 gap-x-1 gap-y-3 sm:gap-y-4 md:gap-x-4 md:gap-y-6`}
    >
      {products.map((product) => (
        <div key={product.id} className="flex w-full min-w-0 flex-col">
          <ProductCard product={product} variant="grid" showQuickAdd={false} />
        </div>
      ))}
    </div>
  );
};

export default ProductGrid;
